import { useNavigate } from 'react-router-dom';
import { HiveFundInvestFlow } from '../components/new-components/HiveFundInvest';
import { useUser } from '../contexts/UserContext';
import { useKycGate } from '../components/new-components/KycGate';
import { Shield } from 'lucide-react';
import { Button } from '../components/new-components/ui/button';

const HiveFundInvest = () => {
  const navigate = useNavigate();
  const { canInvest, kycStatus } = useUser();
  const investCheck = canInvest();

  // Block entire flow if KYC not verified (defense-in-depth for direct URL access)
  if (!investCheck.canInvest) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="bg-card rounded-xl p-8 max-w-md w-full border border-border shadow-xl text-center space-y-4">
          <div className="w-14 h-14 rounded-full bg-amber-500/10 flex items-center justify-center mx-auto">
            <Shield className="w-7 h-7 text-amber-500" />
          </div>
          <h2 className="text-xl font-semibold">Identity Verification Required</h2>
          <p className="text-muted-foreground">
            To comply with federal securities regulations, you must complete identity
            verification (KYC) before investing.
          </p>
          <p className="text-sm text-muted-foreground">
            Current status: <span className="font-medium text-amber-500 capitalize">{kycStatus || 'not started'}</span>
          </p>
          <div className="flex gap-3 pt-2">
            <Button variant="outline" className="flex-1" onClick={() => navigate('/portal/invest/properties')}>
              Browse Offerings
            </Button>
            <Button className="flex-1" onClick={() => navigate('/portal/settings')}>
              Verify Identity
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <HiveFundInvestFlow
      onBack={() => navigate('/portal/invest/properties')}
      onComplete={(_result) => navigate('/portal/portfolio')}
      onGoToSettings={() => navigate('/portal/settings')}
    />
  );
};

export default HiveFundInvest;
